import { Outlet, Link } from "react-router-dom";
import { SignIn, Phone, MapPin } from "@phosphor-icons/react";
import { Toaster } from "sonner";

export default function PortalLayout() {
  return (
    <div className="portal-shell min-h-screen bg-[#F7F6F2] flex flex-col">
      {/* Header — glassmorphism sticky */}
      <header className="sticky top-0 z-20 backdrop-blur-xl bg-[#F7F6F2]/80 border-b border-black/[0.06]">
        <div className="max-w-5xl mx-auto flex items-center justify-between px-4 sm:px-6 h-16">
          <Link to="/portail" className="flex items-center gap-2.5" data-testid="portal-logo">
            <img src="/logo-ecocasse.png" alt="Ecocasse" className="w-10 h-10 object-contain" />
            <div className="leading-tight">
              <div className="font-display font-semibold text-[17px] text-[#1D211F]">Ecocasse</div>
              <div className="text-[11px] text-[#68706A] -mt-0.5">Portail client</div>
            </div>
          </Link>
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-[#68706A] hover:text-[#24593C] transition-colors px-3 py-2 rounded-full hover:bg-black/[0.03]"
            data-testid="portal-staff-login"
          >
            <SignIn size={16} weight="bold" />
            <span className="hidden sm:inline">Espace collaborateur</span>
          </Link>
        </div>
      </header>

      <main className="flex-1 pb-24">
        <Outlet />
      </main>

      {/* Footer — coordonnées Ecocasse */}
      <footer className="border-t border-black/[0.06] bg-white/50" data-testid="portal-footer">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm text-[#68706A]">
          <div>
            <div className="flex items-center gap-2 mb-1.5">
              <img src="/logo-ecocasse.png" alt="Ecocasse" className="w-8 h-8 object-contain" />
              <span className="font-display font-semibold text-[15px] text-[#1D211F]">Ecocasse</span>
            </div>
            <p>Portail client — envoi, suivi et gestion de vos demandes.</p>
          </div>
          <div className="space-y-2.5">
            <div className="flex items-start gap-2" data-testid="portal-address">
              <MapPin size={18} weight="duotone" className="text-[#24593C] shrink-0 mt-0.5" />
              <span>1 rue René Koechlin<br />67150 Gerstheim</span>
            </div>
            <a href="tel:+33388661707" className="inline-flex items-center gap-2 font-medium text-[#1D211F] hover:text-[#24593C] transition-colors" data-testid="portal-phone">
              <Phone size={18} weight="duotone" className="text-[#24593C] shrink-0" />
              03 88 66 17 07
            </a>
          </div>
          <div className="sm:text-right text-xs text-[#A8A399] flex flex-col sm:items-end justify-end gap-1">
            <span>© Ecocasse · Portail client</span>
            <span>Vos données sont traitées conformément au RGPD.</span>
          </div>
        </div>
      </footer>

      <Toaster position="top-center" richColors />
    </div>
  );
}
